import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_ADD_PAYOUT_REQUESTS,
  ACTION_CANCEL_PAYOUT_REQUEST__REQUEST,
  ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
  ACTION_CANCEL_PAYOUT_REQUEST__FAIL,

  ACTION_CREATE_PAYOUT_REQUEST__REQUEST,
  ACTION_CREATE_PAYOUT_REQUEST__FAIL,
  ACTION_CREATE_PAYOUT_REQUEST__SUCCESS,
} from '../actionTypes';


export const actionAddPayoutRequests = payoutRequests => ({
  type: ACTION_ADD_PAYOUT_REQUESTS,
  payload: { payoutRequests },
});


const actionCancelPayoutRequestSuccess = payoutRequestId => ({
  type: ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
  payload: { payoutRequestId },
});

const actionCancelPayoutRequestFail = (payoutRequestId, error) => ({
  type: ACTION_CANCEL_PAYOUT_REQUEST__FAIL,
  payload: { payoutRequestId, error },
});

export const actionCancelPayoutRequestRequest = payoutRequestId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_CANCEL_PAYOUT_REQUEST__REQUEST,
      payload: { payoutRequestId },
    });

    return apiClientHelper.post(
      `/rest/webmaster/payout_request/cancel/${payoutRequestId}`,
      {}
    ).then(
      () => {
        dispatch(actionCancelPayoutRequestSuccess(payoutRequestId));
      },
      error => {
        dispatch(actionCancelPayoutRequestFail(payoutRequestId, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionCreatePayoutRequestSuccess = () => ({
  type: ACTION_CREATE_PAYOUT_REQUEST__SUCCESS,
});

const actionCreatePayoutRequestFail = error => ({
  type: ACTION_CREATE_PAYOUT_REQUEST__FAIL,
  payload: { error },
});

export const actionCreatePayoutRequestRequest = payoutRequestMethod => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_CREATE_PAYOUT_REQUEST__REQUEST,
      payload: { payoutRequestMethod },
    });

    return apiClientHelper.post(
      `/rest/webmaster/payout_request/request_payout/${payoutRequestMethod}`,
      {}
    ).then(
      () => {
        dispatch(actionCreatePayoutRequestSuccess());
      },
      error => {
        dispatch(actionCreatePayoutRequestFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
